import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { LosService } from "../../_LOS/services/los.service";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
declare var $: any;
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { constantUrl } from "../../Shared/constantUrl";
import { EncrDecrService } from "../../AuthGuard/EncrDecrService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { LmsService } from "../../_Lms/services/lms.service";
import { DialogService } from "../../Shared/dialog.service";
import { ToWords } from "to-words";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { QuickLoanService } from "../../_QuickLoan/services/quickLoan.service";

@Component({
  selector: "app-quickloan-dv-deduction-info-view",
  templateUrl: "./quickloan-dv-deduction-info-view.component.html",
  styleUrls: ["./quickloan-dv-deduction-info-view.component.scss"],
  standalone: false
})
export class QuickloanDvDeductionInfoViewComponent implements OnInit {
  // AccountComponent same as LosMyLeadtProcessComponentcurrentUser: any;
  currentUser: any;
  showSpinner: boolean = false;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedCustomerColumns: string[] = [];
  Voucher_Detail_NEW_DEDUCTION: any = { TaxSlab: [] };
  totalCalculatorNewDeduction: any;
  tab: any = "deduction";
  Customer: any = {};
  deductionList: any[] = [];
  receiptList: any[] = [];
  dataSource: any;
  CustomerList: any[] = [];
  dvDetail: any;
  stepArr: any;
  cEIModel: any = {
    Asset_Cost: 0,
    IRR_Type: "Flat",
    EMI_Type: "Monthly",
    ProductId: "",
    IRR_CalculateBy: "ROI",
    Adv_Inst: 0,
  };
  dataSourceCustomer: any;
  dataSourcePop: any = new MatTableDataSource([]);
  displayedColumnsPop: string[] = [
    "LoanId",
    "LoanNo",
    "Product_Name",
    "Customer",
    "PhoneNo",
    "Branch_Name",
    "Action",
  ];
  displayedColumns: string[] = [
    "Id",
    "Type",
    "ApplicationNo",
    "ChagesHead",
    "Account",
    "TaxPercentage",
    "Amount",
    "CollectionOn",
    "CollectionBy",
  ];
  voucherModel: any = { Voucher: {}, Voucher_Detail: [] };
  chargesHeadDropdown: any[] = [];
  accountHeadDropdown: any[] = [];
  Bind_Voucher: any = 1;
  //empBranchDropdown: any[] = [];
  totalCalculator: {
    totalCR: number;
    totalDR: number;
    totalWaiverAmount: number;
    totalDeduction: number;
    totalReceived: number;
    totalBalance: number;
    totalCRTX: number;
    totalDRTX: number;
    totalCRInWord: string;
    totalDRInWord: string;
  };
  OldData: any = { Voucher: [], Voucher_Detail: [] };
  loading: boolean = false;
  @Input() loanSummary: any;
  @Output() action: EventEmitter<any> = new EventEmitter<any>();
  @Input() Processid: any;
  @Input() PageData: any;
  @Input() isNew: boolean;
  @Input() Status: any;
  @Input() Revert_IsEdit: any;
  @Input() ProcessName: any;
  chargesHeadDropdownData: any[] = [];
  constructor(
    private dataSharingService: DataSharingService,
    private dialog: DialogService,
    private _MasterService: MasterService,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private encdec: EncrDecrService,
    private router: Router,
    private losService: LosService,
    private LmsService: LmsService,
    private _QuickLoanService: QuickLoanService
  ) { }

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next(this.ProcessName);
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.DVDetail();
  }
  DVDetail() {
    this.dataSource = null;
    this.voucherModel.Voucher_Detail = [];
    this._QuickLoanService
      .QuickLoan_Get_DV_Details({
        LoanId: this.loanSummary.LoanId
      })
      .subscribe((res: any) => {
        if (res.Item1[0].CODE == -1) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res.Item1[0].Msg,
            ...this.configSuccess,
          });
        } else {
          this.deductionList = res.Item1;
          this.receiptList = res.Item2;
          this.dataSource = new MatTableDataSource(this.receiptList);
          this.showSpinner = false;
          this.initializeVoucher();
          this.deductionList.map((item) => {
            this.chargesHeadDropdownData.push({
              Id: item.ChagesHeadId,
              ChagesHead: item.ChagesHead,
            });
            if (!item.IsTax) {
              this.voucherModel.Voucher_Detail.push({
                ...item,
                isDisbled: true,
                IsLoanChargeable: true,
                isShowIcon: false,
                TaxSlab: [],
              });
              this.OldData.Voucher_Detail.push({
                ...item,
                isDisbled: true,
                IsLoanChargeable: true,
                isShowIcon: false,
                TaxSlab: [],
              });
            } else if (
              this.voucherModel.Voucher_Detail.length >= 1 ||
              this.OldData.Voucher_Detail.length >= 1
            ) {
              this.voucherModel.Voucher_Detail[
                this.voucherModel.Voucher_Detail.length - 1
              ].TaxSlab.push(item);
              this.OldData.Voucher_Detail[
                this.OldData.Voucher_Detail.length - 1
              ].TaxSlab.push(item);
            }
          });
        }

        this.voucherModel.Voucher_Detail.forEach((obj: any, index) => {
          if (
            Number(obj.Bind_Voucher == null ? 0 : Number(obj.Bind_Voucher)) >
            this.Bind_Voucher
          ) {
            this.Bind_Voucher = Number(obj.Bind_Voucher);
          }
          if (
            this.deductionList.filter(
              (result) =>
                result.Bind_Voucher === obj.Bind_Voucher &&
                result.IsTax === true
            ).length > 0
          ) {
            obj.GSTModel = {
              PartyType: "Existing_Party",
              Acc_GSTNo: obj.GST_No,
              Customer: obj.Customer,
              Account_Name: obj.Customer,
              Slab_Tax: this.deductionList.filter(
                (result) =>
                  result.Bind_Voucher === obj.Bind_Voucher &&
                  result.IsTax === true
              )[0].SlabName,
            };
          }
        });
        console.log(
          "this.voucherModel.Voucher_Detailsegrgerdf",
          this.voucherModel.Voucher_Detail
        );

        this.getTotalCalculation();
      })
  }

  changeTab(tab: any) {
    if (tab != this.tab) {
      this.tab = tab;
    }
  }

  initializeVoucher() {
    this.voucherModel.Voucher = {
      Voucher_LoanId: this.loanSummary.LoanId,
      VoucherId: 0,
      Voucher_Type: "Disbursement",
      Voucher_Sub_Type: "Loan",
      Voucher_Tag: "",
      Voucher_Date: new Date(),
      //Voucher_Date: moment(this.dvDetail.LoanDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
      Voucher_No: "",
      DRAccountId: "",
      Voucher_Mode_of_Payment: "",
      Voucher_Total_Credit_Amount: "",
      Voucher_Total_Debit_Amount: "",
      Voucher_Total_Tax: "",
      Voucher_Narration: "",
      Voucher_Cheque_No: "",
      Voucher_Cheque_Date: "",
      Voucher_Bank_Name: "",
      Voucher_Cheque_Clear_Date: "",
      Voucher_E_Transaction_Date: "",
      Voucher_E_Ref_No: "",
      Voucher_ReceiptNo_Book: "",
      Voucher_ReceiptDate: "",
      LoginUserId: this.currentUser.userId,
    };

    this.OldData.Voucher = {
      Voucher_LoanId: this.loanSummary.LoanId,
      VoucherId: 0,
      Voucher_Type: "Disbursement",
      Voucher_Sub_Type: "Loan",
      Voucher_Tag: "",
      Voucher_Date: new Date(),
      Voucher_No: "",
      DRAccountId: "",
      Voucher_Mode_of_Payment: "",
      Voucher_Total_Credit_Amount: "",
      Voucher_Total_Debit_Amount: "",
      Voucher_Total_Tax: "",
      Voucher_Narration: "",
      Voucher_Cheque_No: "",
      Voucher_Cheque_Date: "",
      Voucher_Bank_Name: "",
      Voucher_Cheque_Clear_Date: "",
      Voucher_E_Transaction_Date: "",
      Voucher_E_Ref_No: "",
      Voucher_ReceiptNo_Book: "",
      Voucher_ReceiptDate: "",
      LoginUserId: this.currentUser.userId,
    };
  }

  initializeVoucherDetail() {
    this.voucherModel.Voucher_Detail.splice(
      this.voucherModel.Voucher_Detail.length,
      0,
      {
        Id: 0,
        LoanId: null,
        Type: "CR",
        SlabName: "",
        TaxType: "",
        ApplicationNo: "",
        BranchId: "",
        Branch: "",
        ChagesHeadId: "",
        ChagesHead: "",
        AccountId: "",
        Account: "",
        CustomerID: "",
        Customer: "",
        TaxPercentage: "",
        Amount: "",
        CollectionOn: "",
        CollectionBy: "",
        IsTax: false,
        TaxSlab: [],
        isShowIcon: true,
        isDisbled: false,
        IsLoanChargeable: false,
        GSTModel: {},
        Bind_Voucher: this.Bind_Voucher,
      }
    );
  }

  getChargeshead() {
    this._MasterService
      .Get_ChargesHeadsByProduct_ForDropdow({
        ProductId: this.Voucher_Detail_NEW_DEDUCTION.ProductId,
        IsLoanReceiptDeduction: 1
      })
      .subscribe((res: any) => {
        this.chargesHeadDropdown = res.filter(x => x.Id != 104);
      });
  }

  getTotalCalculation() {
    let _totalCR: any = 0;
    let _totalDR: any = 0;
    let _totalCRTX: any = 0;
    let _totalDRTX: any = 0;
    let _totalWaiverAmount: any = 0;
    let _totalBalance: any = 0;
    let _totalReceived: any = 0;
    let _totalDeduction: any = 0;

    this.voucherModel.Voucher_Detail.forEach((obj: any) => {
      if (obj.Type == "CR") {
        _totalCR = parseFloat(_totalCR) + parseFloat(obj.Amount) || 0;
        _totalWaiverAmount = parseFloat(_totalWaiverAmount) + parseFloat(obj.WaiverAmount) || 0;
        _totalBalance = parseFloat(_totalBalance) + parseFloat(obj.Balance) || 0;
        _totalReceived = parseFloat(_totalReceived) + parseFloat(obj.Received) || 0;
        _totalDeduction = parseFloat(_totalDeduction) + parseFloat(obj.Deduction) || 0;

      } else {
        _totalDR = parseFloat(_totalDR) + parseFloat(obj.Amount) || 0;
      }

      obj.TaxSlab.forEach((tobj: any) => {
        if (obj.Type == "CR") {
          _totalCR = parseFloat(_totalCR) + parseFloat(tobj.Amount) || 0;
          _totalCRTX = parseFloat(_totalCRTX) + parseFloat(tobj.Amount) || 0;
        } else {
          _totalDR = parseFloat(_totalDR) + parseFloat(tobj.Amount) || 0;
          _totalDRTX = parseFloat(_totalDRTX) + parseFloat(tobj.Amount) || 0;
        }
      });
    });

    this.totalCalculator = {
      totalCR: Number(_totalCR),
      totalDR: Number(_totalDR),
      totalWaiverAmount: Number(_totalWaiverAmount),
      totalBalance: Number(_totalBalance),
      totalReceived: Number(_totalReceived),
      totalDeduction: Number(_totalDeduction),

      totalCRTX: Number(_totalCRTX),
      totalDRTX: Number(_totalDRTX),
      totalCRInWord: new ToWords().convert(Number(_totalCR)),
      totalDRInWord: new ToWords().convert(Number(_totalDR)),
    };
  }
  removeData(index: any, data: any) {
    this.dialog
      .openConfirmDialog(`Are you sure you want to remove.`)
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult == false) {
          return;
        } else {
          this.LmsService
            .Delete_ReceiptDeduction({ Id: data.Id })
            .subscribe((res: any) => {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: res[0].MSG,
                ...this.configSuccess,
              });
              this.DVDetail();
            });
        }
      });
    // this.voucherModel.Voucher_Detail.splice(index, 1);
    // this.getTotalCalculation();
  }
  addMoreData() {
    this.Bind_Voucher = this.Bind_Voucher + 1;
    this.initializeVoucherNewDetail();
    $("#dvDetailNewDeduction").modal("show");
    $("#dvDetailNewDeduction").css("z-index", "1050");
  }
  initializeVoucherNewDetail() {
    //console.log("POP : ", this.ACDetailList);
    let data, PrdId;
    this.Customer.ApplicationNo = this.loanSummary.ApplicationNo;
    this.Customer.LoginUserId = this.currentUser.userId;
    this._MasterService
      .Get_SearchCustomerByLMSLOS({ JSON: JSON.stringify(this.Customer) })
      .subscribe((res: any) => {
        data = res.filter((x) => x.LoanId == this.loanSummary.LoanId);
        PrdId = data[0].ProductId;

        this.Voucher_Detail_NEW_DEDUCTION = {
          LoanId: this.loanSummary.LoanId,
          LoginUserId: this.currentUser.userId,
          DeductionLoanId: this.loanSummary.LoanId,
          CaseNo: this.loanSummary.ApplicationNo,
          CustomerId: this.loanSummary.CustomerId,
          Is_LOSAppliaction: "0",
          ChargeHeadId: "",
          ChargeHeadCategory: "",
          AccountId: "",
          BranchId: this.loanSummary.BranchId,
          TranType: "CR",
          IsTax: 0,
          Tax_Per: 0,
          Amount: "",
          Customer: this.loanSummary.Customer,
          Branch_Name: this.loanSummary.Branch,
          ProductId: PrdId,
          TaxSlab: [],
          GSTModel: {},
          Bind_Voucher: this.Bind_Voucher,
          Type: "",
        };
        this.getChargeshead();
      });
  }

  OnCloseSearchNew() {
    $("#dvDetailNewDeduction").modal("hide");
    this.totalCalculatorNewDeduction = null;
  }

  onSaveNewRdDetail() {
    //console.log("Voucher123 : ", this.Voucher_Detail_NEW_DEDUCTION);
    this.showSpinner = true;
    this.Voucher_Detail_NEW_DEDUCTION.IsDvDeductionPage = 1;
    this.LmsService
      .SaveReceiptDeduction({
        JSON: JSON.stringify({ Loaninfo: this.Voucher_Detail_NEW_DEDUCTION }),
      })
      .subscribe((res: any) => {
        //console.log("RES : ", res);
        this.showSpinner = false;
        if (res[0].CODE >= 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });
          this.OnCloseSearchNew();
          this.DVDetail();
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });
        }
      });
  }

  searchCustomer() {
    this.dataSourcePop = new MatTableDataSource([]);
    $("#dvDetailCustomerReceipt").modal("show");
    $("#dvDetailCustomerReceipt").css("z-index", "1150");
    this.Voucher_Detail_NEW_DEDUCTION.SearchValue = "";
    this.Voucher_Detail_NEW_DEDUCTION.Is_LOSAppliaction = "0";
    this.Customer = {};
    setTimeout(() => {
      $("#SearchValue").focus();
    }, 100);
  }
  onChangeChargesHead(data: any) {
    data.Amount = "";
    data.TaxSlab = [];
    this.LmsService
      .Get_AccountHead_For_VoucherEntry({
        HeadId: data.ChargeHeadId,
        VoucherSubType: "Loan",
        ProductId: data.ProductId || 0,
        TaxType: data.TranType,
        LoanNo: data.CaseNo,
      })
      .subscribe((res: any) => {
        if (res.Item1[0]) {
          if (res.Item1[0].AccountId) {
            data.AccountId = res.Item1[0].AccountId;
            data.ChargeHeadCategory = res.Item1[0].AccountName;
            data.TaxSlab = res.Item2;
          } else {
            data.ChagesHeadId = "";
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: "category does not have account head.",
              ...this.configSuccess,
            });
          }
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data Found.",
            ...this.configSuccess,
          });
        }
      });
  }
  onChangeAmount(event: any, data: any) {
    if (event) {
      event.preventDefault();
    }
    data.TaxSlab.forEach((obj: any) => {
      obj.TaxAmount = ((parseFloat(data.Amount) * obj.TaxRate) / 100).toFixed(
        2
      );
    });
    this.getTotalCalculationNew();
  }

  onChangeWaiverAmount(event: any, data: any) {
    if (event) {
      event.preventDefault();
    }
    if (data.WaiverAmount == "") {
      data.WaiverAmount = 0;
      this.getTotalCalculation();
    }
    else if (data.Balance < data.WaiverAmount) {
      data.WaiverAmount = 0;
      data.Amount = data.Balance
      this.getTotalCalculation();
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "WaiverAmount does not greater than Deduction Amount.",
        ...this.configSuccess,
      });
    } else {
      data.Amount = parseFloat(data.Balance) - parseFloat(data.WaiverAmount);
      data.TaxSlab.forEach((obj: any) => {
        obj.Amount = ((parseFloat(data.Amount) * obj.TaxPercentage) / 100).toFixed(2);
      });

      // var _findstock= this.voucherModel.Voucher_Detail.find(x=>x.ChagesHeadId==27);
      //var _find= this.voucherModel.Voucher_Detail.find(x=>x.ChagesHeadId==28);


      var _totalCR: any = 0;
      this.voucherModel.Voucher_Detail.forEach((obj: any) => {
        if (obj.Type == "CR" && obj.ChagesHeadId != 28) {
          _totalCR = parseFloat(_totalCR) + parseFloat(obj.Amount) || 0;
        }

        obj.TaxSlab.forEach((tobj: any) => {
          _totalCR = parseFloat(_totalCR) + parseFloat(tobj.Amount) || 0;

        });
      })
      // _find.Amount=parseFloat(_findstock.Amount) -_totalCR;
      this.getTotalCalculation();
    }
  }
  getTotalCalculationNew() {
    let _total: any = 0;
    let _totalCR: any = 0;
    let _totalTX: any = 0;
    _total =
      parseFloat(_total) +
      parseFloat(this.Voucher_Detail_NEW_DEDUCTION.Amount) || 0;
    _totalCR =
      parseFloat(_totalCR) +
      parseFloat(this.Voucher_Detail_NEW_DEDUCTION.Amount0) || 0;
    this.Voucher_Detail_NEW_DEDUCTION.TaxSlab.forEach((tobj: any) => {
      _total = parseFloat(_total) + parseFloat(tobj.TaxAmount) || 0;
      _totalTX = parseFloat(_totalTX) + parseFloat(tobj.TaxAmount) || 0;
    });
    this.totalCalculatorNewDeduction = {
      total: Number(_total),
      totalCR: Number(_totalCR),
      totaltax: Number(_totalTX),
      totalInWord: new ToWords().convert(Number(_total)),
    };
  }
  OnCloseSearch() {
    $("#dvDetailCustomerReceipt").modal("hide");
    this.Voucher_Detail_NEW_DEDUCTION.SearchValue = "";
  }
  onSearchCustomerDetail() {
    this.Customer.LoginUserId = this.currentUser.userId;
    this._MasterService
      .Get_SearchCustomerByLMSLOS({ JSON: JSON.stringify(this.Customer) })
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.displayedCustomerColumns = [
            "CustomerId",
            "Type",
            "Application_No",
            "LoanAcNo",
            "CustomertName",
            "FatherName",
            "Customer_Gender",
            "GenderAge",
            "PhoneNo",
            "EditAction",
          ];

          this.CustomerList = JSON.parse(JSON.stringify(res));
          // this.CustomerList = this.CustomerList.filter(
          //   (item) => item.Type == "LMS"
          // );
          this.dataSourceCustomer = new MatTableDataSource(this.CustomerList);
          this.dataSourceCustomer.sort = this.sort;
          this.showSpinner = false;
        }
      });
  }
  selectSearchData(data: any) {
    this.Voucher_Detail_NEW_DEDUCTION.DeductionLoanId = data.LoanId;
    this.Voucher_Detail_NEW_DEDUCTION.CaseNo = data.Application_No;
    this.Voucher_Detail_NEW_DEDUCTION.Customer = data.CustomertName;
    this.Voucher_Detail_NEW_DEDUCTION.CustomerId = data.CustomerId;
    this.Voucher_Detail_NEW_DEDUCTION.ProductId = data.ProductId;
    this.Voucher_Detail_NEW_DEDUCTION.BranchId = data.BranchId;
    this.Voucher_Detail_NEW_DEDUCTION.Branch_Name = data.Branch_Name;
    this.Voucher_Detail_NEW_DEDUCTION.ChargeHeadId = "";
    this.Voucher_Detail_NEW_DEDUCTION.Amount = "";
    this.Voucher_Detail_NEW_DEDUCTION.TaxSlab = [];
    this.getChargeshead();
    this.OnCloseSearch();
  }

  saveVoucher() {
    let _vouvher: any = { ...this.voucherModel.Voucher };
    console.log("this.voucherModel.Voucher_Detail", this.voucherModel.Voucher_Detail);

    this._QuickLoanService
      .QuickLoan_Save_DV_Deduction({ JSON: JSON.stringify(this.voucherModel), LoginUserId: this.currentUser.userId })
      .subscribe((res: any) => {
        if (res && res[0].CODE >= 0) {
          this.LmsService
            .LMS_Get_DV_Details({ LoanAcId: this.loanSummary.LoanId, VoucherId: 0 })
            .subscribe((res: any) => {
              this.dvDetail = res.Item1[0];
              this.stepArr = res.Item4;

              let stepEMI: any[] = [];
              for (let i = 0; i < this.stepArr.length; i++) {
                for (let j = +this.stepArr[i].FromEMI; j <= +this.stepArr[i].ToEMI; j++) {
                  if (+this.stepArr[i].EMIAmount >= 0) {
                    stepEMI.push(this.stepArr[i].EMIAmount);
                  }
                }
              }
              this.cEIModel = {
                Disbursement_Amt:
                  Number(this.dvDetail.DisbursementAmount),
                No_Of_Inst: this.dvDetail.NoOfInstallment,
                Adv_Inst: this.dvDetail.Adv_Inst,
                EMI_Type: this.dvDetail.EMI_Type,
                IRR_CalculateBy: stepEMI.length > 0 ? "STEP_EMI" : "FLAT_EMI",
                EMI_Amt: this.dvDetail.EMIAmount,
                cashflow: stepEMI,
                DaysInYear: this.currentUser.DaysInYear,
              };
              if (this.dvDetail.EMI_Type != "SingleEMI") {
                console.log("this.cEIModel", this.cEIModel);
                this.LmsService
                  .Disbursment_CalculateEMIIRR(this.cEIModel)
                  .subscribe((res: any) => {
                    this.showSpinner = false;
                    var emiIrr = res[0];
                    console.log(" emiIrr.Disbursement_IRR", emiIrr.Disbursement_IRR);

                    var Disbursement_IRR = emiIrr.Disbursement_IRR
                    this.LmsService.Update_Disbursement_IRR({
                      LoanId: this.loanSummary.LoanId,
                      DisbIRR: Disbursement_IRR
                    }).subscribe((res: any) => {
                      console.log("Update_Disbursement_IRR", res);
                    });
                  })
              }
            });

          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });
          this.voucherModel.Voucher_Detail = [];
          this.totalCalculator = undefined;
          this.QuickLoan_Save_PageProcess("DV Deduction", this.PageData.MM_Id);
          this.DVDetail();
          this.action.emit("next");
        } else if (res) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });
        }
      });
  }
  QuickLoan_Save_PageProcess(PageType, Page_Id) {
    this._QuickLoanService
      .QuickLoan_Save_PageProcess({
        PageType: PageType,
        ProductId: this.loanSummary.ProductId,
        Loan_Id: this.loanSummary.LoanId,
        Process_Id: this.Processid,
        Page_Id: Page_Id,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res) => {
        //return res[0].CODE;
      });
  }


}